import React, {useEffect} from 'react';

import {utils} from '../utils';
import {theme} from '../constants';

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  preventClose?: boolean;
};

export const BottomSheet: React.FC<Props> = ({
  open,
  onClose,
  title,
  children,
  preventClose,
}) => {
  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    else      document.body.style.overflow = '';
    return () => {document.body.style.overflow = '';};
  }, [open]);

  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1000,
        backgroundColor: 'rgba(20,24,36,0.50)',
        display: 'flex',
        alignItems: 'flex-end',
        animation: 'overlayIn 0.18s ease',
      }}
      role='presentation'
      onClick={() => !preventClose && onClose()}
    >
      <div
        role='dialog'
        aria-modal='true'
        style={{
          backgroundColor: theme.colors.white,
          borderRadius: '20px 20px 0 0',
          width: '100%',
          maxWidth: 650,
          margin: '0 auto',
          padding: '0 20px',
          paddingBottom: 'max(28px, env(safe-area-inset-bottom))',
          animation: 'sheetUp 0.25s cubic-bezier(0.22, 1, 0.36, 1)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Handle */}
        <div style={{...utils.flexCenter(), padding: '12px 0 10px'}}>
          <div style={{
            width: 36,
            height: 3,
            borderRadius: 2,
            backgroundColor: theme.colors.aliceBlue2,
          }} />
        </div>

        {/* Title */}
        <div style={{
          textAlign: 'center',
          marginBottom: 18,
          paddingBottom: 14,
          borderBottom: `1px solid ${theme.colors.aliceBlue2}`,
        }}>
          <span style={{
            fontSize: 16,
            fontWeight: 600,
            color: theme.colors.mainDark,
            fontFamily: "'SS3', sans-serif",
            letterSpacing: '-0.01em',
          }}>
            {title}
          </span>
        </div>

        {children}
      </div>

      <style>{`
        @keyframes overlayIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes sheetUp   { from { transform: translateY(100%); } to { transform: translateY(0); } }
      `}</style>
    </div>
  );
};
